import React from 'react'
import { observer } from 'mobx-react-lite'
import { ArrowUpCircle, Instagram, Facebook, Linkedin, Pinterest, Tiktok } from 'react-bootstrap-icons'

export default observer(function Contact({ campaign, pmSide }) {

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' })

  return (
    <div className='w-full h-full bg-[#161919] border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg'>
      <div className="border-b border-rb-dark-mode p-10">
        <h1 className='font-bold text-white text-2xl'>{campaign.owner_name}</h1>
        <div className="flex justify-between items-center">
          <a href={`mailto:${campaign.owner_email}`} className='text-rb-green text-sm'>{campaign.owner_email}</a>
          {
            !pmSide && (
              <button 
                className='text-white text-sm font-bold flex items-center cursor-pointer'
                onClick={scrollToTop}
              >
                <span className='mr-2 text-white text-sm'>Back to top</span>
                <ArrowUpCircle /> 
              </button>
            )
          }
        </div>
      </div>
      <div className="flex">
        <div className="p-10">
          <h2 className='text-white text-sm font-bold mb-5'>Social</h2>
          <a href='https://www.instagram.com/reachbird/' target='_blank' rel='noopener noreferrer' className='text-white text-sm flex items-center gap-2 mb-1'><Instagram /> Instagram</a>
          <a href='https://www.linkedin.com/company/reachbird-io/' target='_blank' rel='noopener noreferrer' className='text-white text-sm flex items-center gap-2 mb-1'><Linkedin /> Linkedin</a>
          <a href='https://de.pinterest.com/reachbird/' target='_blank' rel='noopener noreferrer' className='text-white text-sm flex items-center gap-2 mb-1'><Pinterest /> Pinterest</a>
          <a href='https://www.facebook.com/reachbird/' target='_blank' rel='noopener noreferrer' className='text-white text-sm flex items-center gap-2 mb-1'><Facebook /> Facebook</a>
          <a href='https://www.tiktok.com/@reachbird_agency' target='_blank' rel='noopener noreferrer' className='text-white text-sm flex items-center gap-2 mb-1'><Tiktok /> TikTok</a>
        </div>
        <div className="flex flex-grow justify-between">
          <div className="p-10">
            <h2 className='text-white text-sm font-bold mb-5'>Contact</h2>
            <p className='text-white text-sm mb-1'>Reachbird Hub:</p>
            <p className='text-white text-sm mb-1'>Streitfeldstraße 25, 81673 Munich</p>
            <p className='text-white text-sm mb-1'>Mail: <a href='mailto:social@reachbird.io' className='text-rb-green'>social@reachbird.io</a></p>
            <p className='text-white text-sm mb-1'>Phone: <a href='tel:+4989411117206' className='text-rb-green'>(+49) 89 411 117 206</a></p>
          </div>
          <div className="p-10 flex gap-2">
            <img src="/static/kununu_TopCompanyBadge_2024.png" alt="Logo" className="h-20" />
            <img src="/static/kununu_TopCompanyBadge_2025.jpg" alt="Logo" className="h-20" />
          </div>
        </div>
      </div>
      <div className="p-10 border-t border-rb-dark-mode">
        <div className="flex justify-between">
          <p className='text-white text-2xl font-bold tracking-widest'>REACHBIRD</p>
          <img src="/static/adesso_logo.png" alt="Logo" className="h-12" />
        </div>
      </div>
    </div>
  )
})